import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import InputAdornment from '@mui/material/InputAdornment';
import { useTheme } from "@mui/material";
import QrCodeIcon from '@mui/icons-material/QrCode';
import { FormContainer, FormErrorProvider, useForm } from "react-hook-form-mui";
import { BoxContainer, CustomTextFieldElement } from "../layouts/Theme";
import { useI18N } from "../context/I18NContext";
export default function Redeem(props) {
    const { t } = useI18N();
    const theme = useTheme();
    const formContext = useForm({});
    const onSubmit = (data, event) => {
    };
    const onError = (errors) => {
    };
    return (_jsxs(BoxContainer, { children: [_jsx(Typography, { sx: { color: theme.palette.text.primary }, variant: "h6", children: t('Cadeaukaart of kortingscode toevoegen') }), _jsx(FormContainer, { formContext: formContext, onSuccess: onSubmit, onError: onError, children: _jsx(FormErrorProvider, { onError: (error) => {
                        if (error.type === 'validate') {
                            console.log(error);
                        }
                        return t(error.type, 'error');
                    }, children: _jsx(CustomTextFieldElement, { required: true, label: t('Vul je code in'), name: 'code', type: "code", InputProps: {
                            startAdornment: (_jsx(InputAdornment, { position: "start", children: _jsx(QrCodeIcon, {}) }))
                        }, sx: { my: 1 }, fullWidth: true }) }) }), _jsx(Button, { fullWidth: true, sx: { my: 1 }, variant: "contained", children: t('Toevoegen') }), _jsx(Alert, { variant: "outlined", severity: "info", sx: { my: 2 }, children: _jsx(Typography, { sx: { color: theme.palette.text.primary }, variant: "body1", children: t('Een kortingscode wordt direct toegepast op je bestelling.') }) }), _jsx(Alert, { variant: "outlined", severity: "info", sx: { my: 2 }, children: _jsx(Typography, { sx: { color: theme.palette.text.primary }, variant: "body1", children: t('Een cadeaukaart wordt toegevoegd aan je gebruikersaccount en kun je daarna voor deze bestelling, maar indien gewenst ook een andere keer gebruiken.') }) })] }));
}
